// @flow
import { KEY } from './constants'
import type { AccountSlice } from './model'

const emptySlice: AccountSlice = {
  template: [],
  templateVersion: null,
  files: [],
  legacy: [],
  archived: [],
  selectedPath: null,
  uploading: false,
}

export const getSlice = (state: Object, number: string): AccountSlice =>
  (state[KEY] && state[KEY].byAccount[number]) || emptySlice

export const getTemplate = (state: Object, number: string) =>
  getSlice(state, number).template

export const getFiles = (state: Object, number: string) =>
  getSlice(state, number).files

export const getArchived = (state: Object, number: string) =>
  getSlice(state, number).archived

export const getLegacy = (state: Object, number: string) =>
  getSlice(state, number).legacy

export const getLegacyCount = (state: Object, number: string): number =>
  getSlice(state, number).legacy.length

export const isUploading = (state: Object, number: string): boolean =>
  getSlice(state, number).uploading

// Active (non-archived) file count, grouped by path.
export const getCountsByPath = (
  state: Object,
  number: string,
): { [path: string]: number } => {
  const counts = {}
  for (const f of getFiles(state, number)) {
    counts[f.path] = (counts[f.path] || 0) + 1
  }
  return counts
}

export const getSelectedPath = (state: Object, number: string): ?string =>
  getSlice(state, number).selectedPath

export const getFilesAtSelectedPath = (
  state: Object,
  number: string,
) => {
  const path = getSelectedPath(state, number)
  if (!path) return []
  return getFiles(state, number).filter((f) => f.path === path)
}

export const getArchivedAtSelectedPath = (
  state: Object,
  number: string,
) => {
  const path = getSelectedPath(state, number)
  if (!path) return []
  return getArchived(state, number).filter((f) => f.path === path)
}
